"use strict";
function shallowEqualWithoutFunctions(objA, objB) {
    if (objA === objB) {
        return true;
    }
    if (typeof objA !== 'object' || objA === null ||
        typeof objB !== 'object' || objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    // Test for A's keys different from B.
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    var componentRegex = /component$/i;
    for (var i = 0; i < keysA.length; i++) {
        if (typeof objA[keysA[i]] !== 'function' || componentRegex.test(keysA[i])) {
            if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
                return false;
            }
        }
    }
    return true;
}
exports.shallowEqualWithoutFunctions = shallowEqualWithoutFunctions;
//# sourceMappingURL=shallowEqualWithoutFunctions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/searchkit/lib/src/core/react/pure-render/shallowEqualWithoutFunctions.js
// module id = 194
// module chunks = 0